import Vue from "vue";
import App from "./App.vue";
import BreadCrumbs from "@/core/components/BreadCrumbs";

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

const {detect} = require("detect-browser");
const browser = detect();

switch (browser && browser.name) {
	case "ie":
	case "edge":
		window.location.href = "https://www.mozilla.org/es-ES/firefox/new/";
		break;
	default:
		break;
}

//constants
import * as constants from "@/constants";

// axios
import axios from "./axios.js";

Vue.prototype.$http = axios;

// API Calls
import "./http/requests";

// mock
import "./fake-db/index.js";

// Theme Configurations
import "../themeConfig.js";

// Firebase
import config from "@/constants/firebase";
import firebase from "firebase/app";
import "firebase/database";
import "firebase/performance";
import "firebase/firestore";
import "firebase/messaging";

// Firebase
export const firebaseInstance = firebase.initializeApp(config);

// Firebase real time database
export const db = firebase.database();

// Firebase Performance Monitoring
export const perf = firebase.performance();

// Initialize Firebase Cloud Messaging and get a reference to the service
export const messaging = firebase.messaging();
Vue.prototype.$messaging = messaging;

export const firebaseChatDB = firebaseInstance.database(process.env.VUE_APP_FIREBASE_DATABASE_CHAT_URL);

// Auth0 Plugin
import AuthPlugin from "./plugins/auth";

Vue.use(AuthPlugin);

// ACL
import acl from "./acl/acl";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "@/assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "@/router";

// Vuex Store
// import store from './store/store'
import store from "@/store";

// i18n
import i18n from "@/i18n";

// Vuexy Admin Filters
import "@/filters";

// Clipboard
import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

// Tour
// import VueTour from 'vue-tour'
// Vue.use(VueTour)
// require('vue-tour/dist/vue-tour.css')

// VeeValidate
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);

// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from "vue2-hammer";

Vue.use(VueHammer);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// https://vuejsexamples.com/a-vue-js-directive-for-animating-an-element-to-and-from-height-auto-in-a-sliding-motion/
import VShowSlide from "v-show-slide";
//Install the plugin
Vue.use(VShowSlide);

Vue.component("BreadCrumbs", BreadCrumbs);
Vue.config.productionTip = false;

new Vue({
	router,
	store,
	i18n,
	acl,
	render: (h) => h(App),
}).$mount("#app");
